import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

////////// # CSS # ----------------------------------------------------------->
import '@/assets/main/fonts/iransans/css/fontiran.css'               // FONT Iransans
import '@/assets/main/fonts/vazir/css/all.css'                       // FONT Vazir
import '@/assets/main/fonts/tabler-icons/tabler-icons.min.css'       // FONT Icon Tabler
import '@/assets/main/css/include.css'                               // Css flag - Payments - Socials

import 'element-plus/dist/index.css';                               // element-plus

import '@style/css/tabler.rtl.css'                                  // Style Orginal
import '@style/css/tabler.vendors.rtl.css'                          // Style Vendors
import '@style/css/tabler.custom.css'                               // Style Custom

const app = createApp(App);
app.use(router);
app.mount('#app');

